import { VALUATION_HEADER_CURRENCIES } from '@dealstack/frontend/app/pages/Valuations/constants';
import { FormInputWrapper } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/styled';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { UTCDateInput } from '@dealstack/frontend/shared/components/mantineForm/UTCDateInput';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { EARLIEST_FX_DATE } from '@dealstack/shared/lib/common/date/date';
import { CurrencyType } from '@dealstack/shared/lib/generated';
import { VALUATION_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { Select } from '@mantine/core';
import { DateTime } from 'luxon';
import { memo } from 'react';
import { Control, useController } from 'react-hook-form';
import { ValuationDetailsForm } from '@dealstack/frontend/app/pages/Valuations/constants.types';
import { FXRatesFormHeader } from './styled';

const FXRateHeader = ({ control }: { control: Control<ValuationDetailsForm> }) => {
	const tValuations = useTranslationValuations();
	const {
		field: { value: valuationDate },
	} = useController({ control, name: 'valuationDate' });
	const {
		field: { value: defaultCurrency, onChange: setDefaultCurrency },
	} = useController({ control, name: 'valuationDefaultCurrency' });

	const handleCurrencyChange = async (defaultCurrency: CurrencyType) => {
		setDefaultCurrency(defaultCurrency);
	};

	return (
		<FXRatesFormHeader>
			<FormInputWrapper>
				<TextV2 variant="sans/14/600">{tValuations('form_field.valuation_date')}</TextV2>
				<UTCDateInput
					data-testid={VALUATION_ELEMENT_ID.FX_EXCHANGE_DRAWER_VALUATION_DATE}
					size="sm"
					name="valuationDate"
					value={
						valuationDate
							? DateTime.fromISO(valuationDate, { zone: 'utc' })
									.setZone('local', { keepLocalTime: true })
									.toJSDate()
							: undefined
					}
					disabled
					valueFormat="DD/MM/YYYY"
					placeholder={tValuations('form_field.valuation_date_placeholder')}
					leftSection={<Icon variant="calendar-v3" size="vlg" />}
					minDate={EARLIEST_FX_DATE.toJSDate()}
				/>
			</FormInputWrapper>
			<FormInputWrapper>
				<TextV2 variant="sans/14/600">{tValuations('form_field.default_currency')}</TextV2>
				<Select
					data-testid={VALUATION_ELEMENT_ID.FX_EXCHANGE_DEFAULT_CURRENCY}
					size="sm"
					data={VALUATION_HEADER_CURRENCIES.map((currency) => ({
						label: currency,
						value: currency,
					}))}
					value={defaultCurrency}
					onChange={handleCurrencyChange}
					placeholder={tValuations('form_field.default_currency_placeholder')}
					rightSection={<Icon variant="caret-down" size="vlg" />}
					rightSectionProps={{ style: { pointerEvents: 'none' } }}
					sx={{
						'input:focus:not([data-invalid])': {
							boxShadow: 'none',
						},
					}}
				/>
			</FormInputWrapper>
		</FXRatesFormHeader>
	);
};
const _FXRateHeaderExport = memo(FXRateHeader);

export { _FXRateHeaderExport as FXRateHeader };
